import {apiPost} from './api.client';
import {getSiteHeader} from './siteHeaderUtils';

let aamClient = (function() {
    let deviceList = [];
    let siteName = null;

    function apiPostSetup(path, payload, headers) {
        if (deviceList) {
            payload.devices = deviceList;
        }
        return apiPost(path, payload, headers);
    }
    let setup = function(devices, site) {
        if (Array.isArray(devices)) {
            deviceList = devices;
        }
        siteName = site;
        return Promise.resolve(deviceList, siteName);
    };
    let getDevices = function() {
        return deviceList;
    };
    let register = function(payload) {
        return apiPostSetup('/auth/aam/v3/register', payload, getSiteHeader(siteName));
    };
    let authenticate = function(payload) {
        return apiPostSetup('/auth/aam/v3/authenticate', payload, getSiteHeader(siteName));
    };
    let passwordChange = function(payload) {
        return apiPostSetup('/auth/aam/v3/password/change', payload, getSiteHeader(siteName));
    };
    let refreshLogin = function() {
        return apiPostSetup('/auth/aam/v3/refreshlogin', {}, getSiteHeader(siteName));
    };
    let passwordReset = function(payload) {
        return apiPostSetup('/auth/aam/v3/password/reset', payload, getSiteHeader(siteName));
    };
    let status = function(payload) {
        return apiPost('/auth/aam/v3/status', payload, getSiteHeader(siteName));
    };
    let tokenStatus = function(payload) {
        return apiPost('/auth/aam/v3/token/status', payload, getSiteHeader(siteName));
    };
    let expediaToken = function(payload) {
        return apiPost('/auth/aam/v3/expedia/token', payload, getSiteHeader(siteName));
    };
    let resendConfirmationEmail = function(payload) {
        return apiPost('/auth/aam/v3/resendConfirmEmail', payload, getSiteHeader(siteName));
    };

    return {
        setup,
        authenticate,
        status,
        register,
        getDevices,
        passwordChange,
        refreshLogin,
        tokenStatus,
        expediaToken,
        passwordReset,
        resendConfirmationEmail
    };
}());

export default aamClient;
